import { render, staticRenderFns } from "./AboutCompany.vue?vue&type=template&id=3b2bbb54"
import script from "./AboutCompany.vue?vue&type=script&lang=js"
export * from "./AboutCompany.vue?vue&type=script&lang=js"
import style0 from "./AboutCompany.vue?vue&type=style&index=0&id=3b2bbb54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports